import { action, observable, computed, makeObservable } from 'mobx';
import { MultibetItemState } from 'src/domains/sportsbook/betting/state/multibetState/MultibetItemState';
import { BetslipMultibetId } from 'src/domains/sportsbook/betting/models/BetslipIdModels';
import { BetslipCommandType } from 'src/domains/sportsbook/betting/state/multibetState/Types';
import { MultibetBetType } from 'src/domains/sportsbook/betting/betting/postPlaceBet';
import { Common } from 'src/domains/common/Common';
import { AutoWeakMap } from 'src_common/common/mobx-utils/AutoWeakMap';

export class MultibetState {
    public static get = AutoWeakMap.create((common: Common) => new MultibetState(common));

    @observable private itemsInBetslip: Array<MultibetItemState> = [];

    private constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @action public addToBetslip = (command: BetslipCommandType): void => {
        if (command.sportsbookFixtureId === undefined || command.sportsbookFixtureId === '') {
            return;
        }

        if (command.selections === undefined || command.selections.length < 2) {
            return;
        }

        const newMultibetItem = new MultibetItemState(this.common, command);

        this.itemsInBetslip = [...this.itemsInBetslip, newMultibetItem];
    };

    @action public removeFromBetslip = (multibetId: BetslipMultibetId): void => {
        this.itemsInBetslip = this.itemsInBetslip.filter((item) => item.id !== multibetId);
    };

    @action public acceptChanges(): void {
        this.itemsInBetslip.map((itemValue: MultibetItemState) => {
            itemValue.acceptChanges();
        });
    }

    @computed public get activeBets(): Array<MultibetItemState> {
        return [...this.itemsInBetslip];
    }

    @computed public get activeBets2(): Array<BetslipMultibetId> {
        return this.itemsInBetslip.map((item) => item.id);
    }

    @computed public get areBetsWithoutOffer(): boolean {
        return this.activeBets.some((bet) => bet.multibetOffer.length === 0);
    }

    @computed public get suspendedBets(): Array<MultibetItemState> {
        return this.itemsInBetslip.filter((multibetItem) => multibetItem.multibetStatus.suspendedBets);
    }

    @computed public get expiredBets(): Array<MultibetItemState> {
        return this.itemsInBetslip.filter((multibetItem) => multibetItem.multibetStatus.expiredBets);
    }

    @computed public get hasMultibetErrors(): boolean {
        return this.itemsInBetslip.some(
            (item) =>
                item.multibetStatus.expiredBets ||
                item.multibetStatus.suspendedBets ||
                item.multibetStatus.conflictingBets
        );
    }

    public getMultibetBets(): Array<MultibetBetType> {
        const bets: Array<MultibetBetType> = [];
        for (const item of this.itemsInBetslip) {
            const multibetBet = item.getMultibetBet();

            if (multibetBet !== null) {
                bets.push(multibetBet);
            }
        }

        return bets;
    }

    @action public clearAllMultibetData = (): void => {
        this.removeAllFromBetslip();
    };

    @action public removeAllFromBetslip(): void {
        this.itemsInBetslip = [];
    }
}
